import Track from './tracking';

export default function forwardToPaymentURL(url) {
  const timeoutCookieExpiry = Number(window.start.settings?.timeout_cookie_expiry_hosted_payment) || 6 * 60 * 60;
  const sessionTimeoutEnabled = window.start.settings?.session_timeout_enabled;
  if (sessionTimeoutEnabled && sessionTimeoutEnabled !== 'false') {
    fetch(`https://${window.location.host}/checkout/session-timeout/update?expiryTime=${
      timeoutCookieExpiry}`, {
      method: 'POST',
      headers: {
        'x-thg-client': 'checkout-web-js',
      },
    }).then((response) => {
      if (!response.ok) {
        Track.error('Failed to add session timeout cookie.');
      }
    }).catch(err => Track.error(`Error when adding session timeout cookie: ${err}`));
  }
  setTimeout(() => {
    window.location = url;
  }, 1000);
}
